import React, { useEffect } from 'react';
import OverviewComp from './components/OverviewComp';
import { View } from '../../components/Common/react-native-components';
import { useDispatch } from 'react-redux';
import { clearOverviewData } from './actions/fetchOverViewData';

const Overview = () => {
  const dispatch = useDispatch();

  // useEffect(() => {
  //   return () => dispatch(clearOverviewData());
  // }, []);
  return (
    <View style={{ marginTop: 20 }}>
      <OverviewComp />
    </View>
  );
};
export default Overview;
